import { action } from 'satcheljs';
import { CalendarEventsFilters } from '../utils/CalendarEventsFilters';

export const removeFilter = action(
    'REMOVE_FILTER',
    (filterKey: string, currentFilters: (CalendarEventsFilters | string)[]) => ({
        filterKey,
        currentFilters,
    })
);
